<mat-toolbar fxLayout="row" fxLayoutAlign="center center" [ngClass]="{
    'logged-in': user$ | async,
    'user-role-admin': (user$ | async)?.hasRole('ADMIN')
  }">
  <button class="home-btn" mat-icon-button matTooltip="Home" *ngIf="user$ | async" routerLink="/">
    <mat-icon>home</mat-icon>
  </button>
  <div *ngIf="user$ | async; let user">
    <div *ngIf="user.hasRole('ADMIN')">
      <button class="menu-item" mat-stroked-button *ngIf="user$ | async" routerLink="/itineraries"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        Itinerari
      </button>
      <button class="menu-item" mat-stroked-button *ngIf="user$ | async" routerLink="/users" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        Utenti
      </button>
      <button class="menu-item" mat-stroked-button *ngIf="user$ | async" routerLink="/coupons" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        Codici Sconto
      </button>
      <button class="menu-item" mat-stroked-button *ngIf="user$ | async" routerLink="/carts" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        Carrelli
      </button>
      <button class="menu-item" mat-stroked-button *ngIf="user$ | async" routerLink="/dashboard"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        Dashboard
      </button>
    </div>
  </div>

  <span fxFlex></span>
  <a routerLink="/" class="brand"><img src="/assets/logo.png" alt="my QuoVado" /></a>
  <span fxFlex></span>
  <div *ngIf="user$ | async; let user" fxHide.xs>
    <a class="help-btn" mat-icon-button matTooltip="Guida" *ngIf="user && user.hasRole('TRAVEL_ADVISOR')"
      href="https://docs.google.com/document/d/1_F0--5O1lB6cr3J2Zbe5qWlX9zdg_9CJk47hEWFfbDA" target="_blank">
      <mat-icon>help</mat-icon>
    </a>
  </div>
  <div *ngIf="user$ | async; let user">
    <button class="user-profile-btn" mat-icon-button matTooltip="Profilo" *ngIf="user && user.hasRole('TRAVEL_ADVISOR')"
      routerLink="/user/me">
      <mat-icon>person</mat-icon>
    </button>
  </div>
  <button mat-icon-button matTooltip="Esci" *ngIf="user$ | async" routerLink="/logout">
    <mat-icon>exit_to_app</mat-icon>
  </button>
</mat-toolbar>